import { createFileRoute } from '@tanstack/react-router';
import { RevenueDashboard } from '@/components/revenue/revenue-dashboard';

export const Route = createFileRoute('/_auth/_side-layout/revenue')({
  component: RevenueDashboard,
});
